import { Component, Inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import { AgGridAngular } from "ag-grid-angular";
import { EligibilitySite } from '../../../models/eligibility-site';
import { ColDef } from 'ag-grid-community';

@Component({
  selector: 'app-select-offer-modal-component',
  imports: [MatDialogModule, MatButtonModule, AgGridAngular],
  templateUrl: './select-offer-modal-component.html',
  styleUrl: './select-offer-modal-component.css',
})
export class SelectOfferModalComponent {

  readonly columnDefs: ColDef[] = [
    {
      headerName: 'Référence',
      field: 'reference',
      filter: "agTextColumnFilter",
      floatingFilter: true,
      minWidth: 250
    },
    {
      headerName: 'Désignation',
      field: 'name',
      filter: "agTextColumnFilter",
      floatingFilter: true,
      minWidth: 400
    },
    {
      headerName: 'Opérateur',
      field: 'provider',
      filter: "agTextColumnFilter",
      floatingFilter: true,
    },
    {
      headerName: 'Technologie',
      field: 'technology',
      filter: "agTextColumnFilter",
      floatingFilter: true,
    },
    {
      headerName: 'Durée d\'engagement',
      field: 'commitmentDuration',
      filter: "agTextColumnFilter",
      floatingFilter: true,
    },
    {
      headerName: 'Prix FMS/FAS',
      field: 'accessFee',
    },
    {
      headerName: 'Prix abonnement',
      field: 'subscriptionPrice',
    }
  ];
  readonly rows = [
    {
      reference: 'FO-V-OR-FTTEENT-Z1-1000-1',
      name: 'Fibre Orange FTTE 1Gbit/s service VPN Basic - 12 mois',
      provider: 'Orange',
      technology: 'FTTE',
      commitmentDuration: 12,
      accessFee: 858.82,
      subscriptionPrice: 371.76
    },
    {
      reference: 'FO-V-OR-FTTEENT-Z1-1000-3',
      name: 'Fibre Orange FTTE 1Gbit/s service VPN Basic - 36 mois',
      provider: 'Orange',
      technology: 'FTTE',
      commitmentDuration: 36,
      accessFee: 858.82,
      subscriptionPrice: 371.76
    },
    {
      reference: 'FO-I-OR-FTTEENT-Z1-1000-1',
      name: 'Fibre Orange FTTE 1Gbit/s service Internet Basic - 12 mois',
      provider: 'Orange',
      technology: 'FTTE',
      commitmentDuration: 12,
      accessFee: 858.82,
      subscriptionPrice: 374.12
    }
    ,
    {
      reference: 'FO-I-OR-FTTEENT-Z1-1000-3',
      name: 'Fibre Orange FTTE 1Gbit/s service Internet Basic - 36 mois',
      provider: 'Orange',
      technology: 'FTTE',
      commitmentDuration: 36,
      accessFee: 858.82,
      subscriptionPrice: 374.12
    }
  ]

  readonly site = signal<EligibilitySite | null>(null);

  constructor(@Inject(MAT_DIALOG_DATA) private readonly data: any) {}

  ngOnInit() {
    this.site.set(this.data.site);
  }
}
